<script>import { api, Formrow, Button, IconSearch, IconSpinner, Alert } from "duo-kit";
import { fade } from "svelte/transition";
let qs = new URLSearchParams(window.location.search);
let q = qs.get("search");
let loading = false;
let results = [];
let answer = null;
let answering = false;
let references;

async function ask() {
  answering = true;

  try {
    let res = await api.load({
      url: `/duocms/api/nafems/gask?${new URLSearchParams({
        q: q
      })}`
    });
    answer = res.data.answer.state == "SUCCEEDED" ? res.data.answer.answerText : null;
    references = res.data.answer.references;
  } catch (err) {}

  answering = false;
}

async function search() {
  loading = true;
  const url = new URL(window.location); // updating qs

  url.searchParams.set("search", q);
  history.pushState(null, '', url);
  ask(); // don't await

  let res = await api.load({
    url: `/duocms/api/nafems/gsearch?${new URLSearchParams({
      q: q
    })}`
  });
  results = res.data.results;
  loading = false;
}

if (q) {
  search();
}</script>

<form on:submit|preventDefault={search}>
  <Formrow type="text" bind:value={q} placeholder="Accepts a question or search">
    <div slot="suffix">
      <Button mode="primary" type="submit" disabled={loading}>
        {#if loading}<IconSpinner />{:else}<IconSearch />{/if}
      </Button>
    </div>
  </Formrow>
</form>

<div class="layout">
  {#if answering || answer}
    <div class="answer">
      {#if answering}
        <p><IconSpinner /> Thinking... </p>
      {:else if !answering && answer}
        <p transition:fade>{answer}</p>
        <p transition:fade class="info">
          <span class="fa fa-info-circle"></span> AI responses may include mistakes. <a href="/about-us/legal/privacy/" target="_blank">Privacy Policy</a>
        </p>
      {/if}
    </div>
  {/if}

  <div class="results">
    {#if results.length}
      <ol>
      {#each results as result}
        <li>
          <a href={result.document.derivedStructData.link}><h3>{@html result.document.derivedStructData.htmlTitle}</h3></a>
          {#each result.document.derivedStructData.extractive_answers.map(e => e.content) as content}
            <p class="shottext">{@html content}</p>
          {/each}
        </li>
      {/each}
      </ol>
    {/if}
  </div>
</div>

<style>
  form{
    --s-primary:#c00;
  }
  .layout{
    display:flex;
    flex-direction: column;
    gap:30px;
  }
  .answer{
    padding:40px;
    border:1px solid #ddd;
    border-radius:5px;
    margin:5px;
    position: relative;
  }
  .answer p{
    font-size:21px;
  }
  .answer p.info{
    font-size:14px;
    position: absolute;
    background:white;
    padding:10px 20px;
    bottom:-30px;
    right:10px;
  }

  .shottext {
   overflow: hidden;
   display: -webkit-box;
   -webkit-line-clamp: 3; /* number of lines to show */
           line-clamp: 3; 
   -webkit-box-orient: vertical;
  }

  a h3 {
    color:#c00;
  }
</style>